export default "__VITE_ASSET__DtBu0EIy__"